import { Liste } from '@mairistem/liste';
import { newIdentifiant } from '@mairistem/tools';
import React from 'react';
import { useHistory } from 'react-router';
import { baseUrlFront } from '@/routes';
import type { PayeurType } from '@/types';
import { useRegieStore } from '@/zustand';
import PayeurListeTable from './PayeurListeTable';

interface PayeurListeProps {
  payeurs?: Array<PayeurType>;
  count?: number;
  perPage?: number;
  loading?: boolean;
  onLoad?: any;
  onSearch?: any;
  onSort?: any;
  onExplored?: any;
  onExpanded?: any;
  state?: any;
  mode?: 'expander' | 'explorer';
  redirectOnEmpty?: boolean;
}
const PayeurListe = (props: PayeurListeProps) => {
  const { payeurs, count, perPage, loading, onLoad, onSort, mode, redirectOnEmpty, ...handlers } =
    props;

  const history = useHistory();
  const regieAutonome = useRegieStore((state) => state.regie?.autonome);
  const hasRedirected = React.useRef(false);

  React.useEffect(() => {
    if (
      redirectOnEmpty &&
      regieAutonome &&
      loading === false &&
      count === 0 &&
      !hasRedirected.current
    ) {
      hasRedirected.current = true;
      history.push(`${baseUrlFront}/payeurs/${newIdentifiant()}`);
    }
  }, [redirectOnEmpty, regieAutonome, loading, count, history]);

  const handleSelect = React.useCallback(
    (item) => {
      history.push(`${baseUrlFront}/payeurs/${item.identifiant}`);
    },
    [history],
  );

  return (
    <Liste
      title=""
      mode={mode}
      searchable
      search={{
        clearable: true,
        placeholder: 'Recherche un nom de payeur...',
        autoFocus: true,
      }}
      {...handlers}
    >
      <Liste.Header> </Liste.Header>
      <Liste.Content>
        {/* -70px la hauteur de la barre de recherche */}
        <div style={{ height: 'calc(100% - 100px)' }}>
          <PayeurListeTable
            mode={mode}
            items={payeurs}
            loading={loading}
            count={count}
            perPage={perPage}
            onLoad={onLoad}
            onSort={onSort}
            onSelect={handleSelect}
          />
        </div>
      </Liste.Content>
    </Liste>
  );
};

export default PayeurListe;
